@if (parentTable.topOptions) {
  <div class="row justify-content-between m-x-2">
    @if (!parentTable.isModernLayout) {
      <app-table-actions [actions]="parentTable.topOptions.topActions" [selection]="parentTable.selection" />
    }
    <div
      class="table-toolbar"
      [class.modern-table-toolbar]="parentTable.isModernLayout">
      @if (parentTable.topOptions.showSearch) {
        <mat-form-field appearance="outline" class="table-search hide-hint tight-input relative">
          <i-tabler matPrefix name="search" class="m-l-8 h-4! w-4!" />
          <input matInput [placeholder]="'search' | translate" (keyup)="onSearch($event)" [(ngModel)]="currentSearchText" />
          @if (currentSearchText) {
            <button
              type="button"
              mat-icon-button
              matSuffix
              class="mr-2 flex! h-7! w-7! shrink-0! items-center! justify-center! p-0! leading-none! text-(--mat-sys-on-surface-variant)! hover:text-(--mat-sys-primary)!"
              aria-label="Clear search"
              title="Clear search"
              (mousedown)="$event.preventDefault()"
              (click)="clearSearch()"
            >
              <i-tabler name="x" class="" />
            </button>
          }
        </mat-form-field>
      }
      @if (parentTable.isModernLayout) {
        @if (parentTable.tableConfig?.columnConfig; as columnConfig) {
          <app-filter-table-v2
            class="modern-table-filter"
            [columnConfig]="columnConfig"
            [initialFilterValues]="parentTable.filterV2Values"
            (filterChange)="parentTable.handleFilterV2($event)" />
        }
      } @else {
        <app-filter-table [filterTableConfig]="filterTableConfig" [handleFilterTable]="handleFilterTable" />
      }
      @if (parentTable.isModernLayout && parentTable.topOptions.inlineActions) {
        <app-table-actions
          class="modern-inline-actions ml-auto"
          [actions]="parentTable.modernTopActions"
          [selection]="parentTable.selection"
          [layout]="parentTable.TableLayout.MODERN" />
      }
    </div>
  </div>
}
